export const PageNames = {
  Login: 'login-page',
  Calendar: 'calendar-page',
  Orders: 'orders-page',
  Payments: 'payments-page',
  Archive: 'archive-page',
  Customers: 'customers-page',
  CustomerProfile: 'customer-profile-page',
  Promo: 'promo-page',
  PromoCertificates: 'promo-certificates-page',
  Analytics: 'analytics-page',
  Services: 'services-page',
  Profile: 'profile-page',
  Company: 'company-id',
} as const

export type PageNames = (typeof PageNames)[keyof typeof PageNames]

export const PageLabels = {
  [PageNames.Calendar]: 'nav.calendar',
  [PageNames.Orders]: 'nav.bookings',
  [PageNames.Payments]: 'nav.payments',
  [PageNames.Archive]: 'nav.archive',
  [PageNames.Customers]: 'nav.clients',
  [PageNames.CustomerProfile]: 'nav.customer_profile',
  [PageNames.Promo]: 'nav.promo',
  [PageNames.PromoCertificates]: 'nav.promo',
  [PageNames.Analytics]: 'nav.analytic',
  [PageNames.Services]: 'nav.services',
  [PageNames.Company]: 'company.settings.title',
  [PageNames.Profile]: 'nav.profile',
} as const
